import { ChevronDown } from 'lucide-react-native';
import { iconWithClassName } from './iconWithClassName';

iconWithClassName(ChevronDown);
export { ChevronDown };
